import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// Services
import { ServiceBase } from '../../service-base';

// Modèles
import { Transaction } from 'src/app/@shared/models/banking/abstract/transaction.model';

/**
 * Base commune aux services des transactions financières (BankAccountLine, Cheque,
 * CardReceipt, CreditCardTransaction, CashTransaction).
 *
 * Factorise le signalement de problème (« issue flag ») : endpoint dédié
 * `POST`/`DELETE {id}/issue-flag/`, écriture ciblée sur les 3 champs
 * (`issueFlag`/`issueFlagDate`/`issueFlagUser`), réponse réhydratée depuis `value`.
 *
 * Les deux appels passent par `_postAction$` / `_deleteAction$` : un refus du serveur
 * s'affiche comme n'importe quel message métier — par exemple
 * `BANK_ACCOUNT_LINE_DUPLICATE_READ_ONLY` sur une ligne signalée doublon (#1230).
 */
export abstract class TransactionServiceBase extends ServiceBase {

    constructor(className: string, endpoint: string) {
        super(className, endpoint);
        this.addRoutes([{ key: 'issueFlag', path: '{id}/issue-flag/' }]);
    }

    /**
     * Retire le signalement de problème (endpoint dédié, écriture ciblée).
     * Retourne la transaction réhydratée depuis la réponse.
     */
    public removeIssueFlag$(transaction: Transaction): Observable<Transaction> {
        let url = this.routes.issueFlag.replace('{id}', transaction.id.toString());
        return this._deleteAction$<Transaction>(url).pipe(
            tap(instance => this._updated$.next(instance))
        );
    }

    /**
     * Pose le signalement de problème (endpoint dédié, écriture ciblée).
     * Retourne la transaction réhydratée depuis la réponse.
     */
    public setIssueFlag$(transaction: Transaction): Observable<Transaction> {
        let url = this.routes.issueFlag.replace('{id}', transaction.id.toString());
        return this._postAction$<Transaction>(url, null).pipe(
            tap(instance => this._updated$.next(instance))
        );
    }
}
